// imports
import { gsap, ScrollToPlugin } from 'gsap/all';
// import Ticker from 'minsky-kit/js/managers/Ticker';
import WAcccordion from './WAccordion';

// register plugins
gsap.registerPlugin(ScrollToPlugin);

// private statics
let ID = 0;

// class definition
export default class MenuAccordion extends WAcccordion {
    // constructor
    constructor (args = {}, objectName = 'MenuAccordion') {
        args.group = ID++;
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // this.mobile = false;

        // transition ticker
        // this._transitionTicker = new Ticker({
        //     timeout:    1000 / 60,
        //     isInterval: true,
        // });

        // add listeners
        // this._transitionTicker.on('tick', this.blm.add('transitionTick', onTransitionTick));
        // this.$contentWrapper.addEventListener('transitionstart', this.blm.add('onTransitionStart', onTransitionStart));
        // this.$contentWrapper.addEventListener('transitionend', this.blm.add('onTransitionEnd', onTransitionEnd));
    }

    // methods
    // open (...args) {
    //     super.open(...args);
    // }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// // Event handlers
// function onTransitionStart () {
//     if (this.mobile && this.isOpen) {
//         this._transitionTicker.start();

//         gsap.to(window, {
//             scrollTo:  {
//                 y:       () => this.$el,
//                 offsetY: 100,
//             },
//             duration:  0.5,
//             delay:     0.35,
//             ease:      'Power2.easeInOut',
//             overwrite: true,
//         });
//     }
// }

// function onTransitionEnd () {
//     this._transitionTicker.stop(true);

//     // gsap.to(window, {
//     //     scrollTo:  {
//     //         y:       () => this.$el,
//     //         offsetY: 100,
//     //     },
//     //     duration:  0.5,
//     //     ease:      'Power2.easeOut',
//     //     overwrite: true,
//     // });
// }

// function onTransitionTick () {
//     // console.log('tick');
//     // gsap.killTweensOf(window);
//     // gsap.to(window, {
//     //     scrollTo:  {
//     //         y:       () => this.$el,
//     //         offsetY: 100,
//     //     },
//     //     duration:  1,
//     //     ease:      'Power2.easeOut',
//     //     overwrite: true,
//     // });
// }
